import { useState } from 'react';
import { CalendarTodayOutlined } from '@mui/icons-material';
import { LoadingState } from '@practium/ui';
import { PARCELLING_BALANCE_UNIT_OPTIONS } from '../../constants/maintenance.constants';
import type { ParcellingBalanceUnit } from '../../types';
import type { CycleCalendarData } from '../../utils/dynamicParcellingCycle';
import { CollapsibleCard } from '../CollapsibleCard/CollapsibleCard';
import { CycleCalendarModal } from '../CycleCalendar/CycleCalendarModal';
import { SegmentedToggle } from '../SegmentedToggle/SegmentedToggle';
import {
	ParcellingTable,
	type ParcellingTableRow,
} from '../Tables/ParcellingTable/ParcellingTable';
import styles from './ParcellingPreview.module.css';

export interface ParcellingPreviewProps {
	rows: ParcellingTableRow[];
	unit: ParcellingBalanceUnit;
	onUnitChange: (unit: ParcellingBalanceUnit) => void;
	isLoading?: boolean;
	emptyMessage?: string;
	calendar?: CycleCalendarData | null;
}

export const ParcellingPreview = ({
	rows,
	unit,
	onUnitChange,
	isLoading,
	emptyMessage,
	calendar,
}: ParcellingPreviewProps) => {
	const [isCalendarOpen, setIsCalendarOpen] = useState(false);

	const renderBody = () => {
		if (isLoading) return <LoadingState />;
		if (!rows.length) return <p className={styles.emptyMessage}>{emptyMessage}</p>;
		return <ParcellingTable rows={rows} />;
	};

	return (
		<>
			<CollapsibleCard
				title="Balanço Nutricional Parcelado"
				defaultOpen
				headerExtra={
					<div className={styles.headerActions}>
						{calendar && (
							<button
								type="button"
								className={styles.calendarButton}
								onClick={() => setIsCalendarOpen(true)}
							>
								<CalendarTodayOutlined className={styles.calendarIcon} />
								Calendário
							</button>
						)}
						<SegmentedToggle
							options={PARCELLING_BALANCE_UNIT_OPTIONS}
							value={unit}
							onChange={onUnitChange}
							ariaLabel="Unidade de medida"
						/>
					</div>
				}
			>
				{renderBody()}
			</CollapsibleCard>
			{calendar && (
				<CycleCalendarModal
					isOpen={isCalendarOpen}
					onClose={() => setIsCalendarOpen(false)}
					calendar={calendar}
				/>
			)}
		</>
	);
};
